const Smile = () => {
    return (
        <svg width="1401" height="438" viewBox="0 0 1401 438" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="1370.47" cy="30.5301" r="30.5301" fill="#208570" />
            <path
                d="M-714 47.375C-407.333 299.272 23.9547 428.948 464.636 401.757C800.744 381.018 1018.85 316.179 1257.83 134.723"
                stroke="url(#paint0_linear_1_222)"
                strokeWidth="64"
                strokeLinecap="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1_222"
                    x1="1042.36"
                    y1="203.108"
                    x2="-416.77"
                    y2="156.722"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.490264" stopColor="#1F856F" />
                    <stop offset="1" stopColor="#1F856F" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Smile;
